<script setup lang="ts">
import { toRefs } from 'vue';

import { useYardAreaPresenterV2 } from '@satellite/composables/useYardAreaPresenterV2';

import type { Maybe } from '@nova/core';
import type { YardArea } from '@satellite/composables/useYardAreaPresenterV2';

const props = withDefaults(
  defineProps<{
    size?: 'regular' | 'small';
    area?: Maybe<YardArea>;
    areaId?: Maybe<string>;
  }>(),
  {
    size: 'regular',
    area: null,
    areaId: null
  }
);

const { areaId, area } = toRefs(props);

const { areaName, isLoading, onIntersect } = useYardAreaPresenterV2({
  areaId,
  area,
  live: true
});
</script>

<template>
  <v-skeleton-loader
    :loading="isLoading"
    type="text"
    v-intersect="{
      handler: onIntersect,
      options: {
        threshold: [0.5]
      }
    }">
    <div class="d-flex flex-column gap-1 yard-area-presenter" style="min-width: 50px">
      <span
        :class="size === 'small' ? 'typography-body-sm' : 'typography-body-md'"
        data-testid="yard-area-presenter-area-name">
        {{ areaName || '-' }}
      </span>
    </div>
  </v-skeleton-loader>
</template>

<style scoped>
:deep(.v-skeleton-loader__text) {
  /** this value makes the loader have the same vertical spacing as the area name text */
  margin: 6px 0 !important;
}
</style>
